export default __webpack_public_path__ + "static/media/ic-price.dde5d4f6.svg";